import {IconName}                                                                                                        from '@fortawesome/fontawesome-common-types';
import type {Timestamp}                                                                                                  from 'firebase-admin/firestore';
import {HexColor, TwColorType}                                                                                           from '../../ui/ui.types';
import {PointWithData}                                                                                                   from '../../utils/utils.types';
import {BodyRecordLogIntf}                                                                                               from '../crud/body.types';
import {CaffRecordLogIntf}                                                                                               from '../crud/caff.types';
import {FoodRecordLogIntf}                                                                                               from '../crud/food.types';
import {MedsRecordLogIntf}                                                                                               from '../crud/meds.types';
import {MindRecordLogIntf}                                                                                               from '../crud/mind.types';
import {MoodRecordLogIntf}                                                                                               from '../crud/mood.types';
import {VapeRecordLogIntf}                                                                                               from '../crud/vape.types';
import {HkitHeartAlertsIntf, HkitMasterType, HkitRecordLogIntf, HkitRecordOddType, HkitRecordUnionType, HkitWorkoutIntf} from '../hkit/hkit.types';
import {OuraHeartIntf, OuraMasterType, OuraRecordLogType, OuraSleepIntf}                                                 from '../oura/oura.types';
import {ActiveRecordModel, Session}                                                                                      from '../rize/graphql.generated';
import {RizeMasterType}                                                                                                  from '../rize/rize.types';


export type CrudRecordType =
	| 'vape'
	| 'meds'
	| 'mood'
	| 'mind'
	| 'body'
	| 'caff'
	| 'food'

export const CrudRecordTypes: CrudRecordType[] = [
	'vape',
	'meds',
	'mood',
	'mind',
	'body',
	'caff',
	'food'
]


export type CrudRecordIntf =
	| VapeRecordLogIntf
	| MedsRecordLogIntf
	| MoodRecordLogIntf
	| MindRecordLogIntf
	| BodyRecordLogIntf
	| CaffRecordLogIntf
	| FoodRecordLogIntf

export type GlobalGroupType =
	| HkitMasterType
	| CrudRecordType
	| RizeMasterType
	| OuraMasterType

export type GlobalRecordType =
	| RizeMasterType
	| CrudRecordType
	| OuraRecordLogType
	| HkitRecordOddType
	| HkitRecordUnionType

export type GlobalRecordIntf =
	| CrudRecordIntf
	| HkitRecordLogIntf
	| HkitWorkoutIntf
	| HkitHeartAlertsIntf
	| OuraSleepIntf
	| OuraHeartIntf
	| Session
	| ActiveRecordModel


export interface GlobalRecordTypeMaps extends Record<GlobalRecordType, GlobalRecordIntf> {
	vape: VapeRecordLogIntf;
	meds: MedsRecordLogIntf;
	caff: CaffRecordLogIntf;
	mood: MoodRecordLogIntf;
	food: FoodRecordLogIntf;
	mind: MindRecordLogIntf;
	body: BodyRecordLogIntf;
	blood_oxygen_saturation: HkitRecordLogIntf;
	dietary_water: HkitRecordLogIntf;
	environmental_audio_exposure: HkitRecordLogIntf;
	handwashing: HkitRecordLogIntf;
	headphone_audio_exposure: HkitRecordLogIntf;
	respiratory_rate: HkitRecordLogIntf;
	toothbrushing: HkitRecordLogIntf;
	weight_body_mass: HkitRecordLogIntf;
	sleep: OuraSleepIntf;
	heart: OuraHeartIntf;
}


export interface GlobalDictDataIntf<T> {
	svc?: any;
	name: string;
	type: T;
	icon: IconName;
	colorTw: TwColorType;
	colorHex?: string;
	dict?: GlobalDictType<any>;
	tooltip?: (datapoint: PointWithData, helper?: Function) => string | string[]
}

export interface NewGlobalDictDataIntf {
	name: string;
	icon: IconName;
	dict?: NewGlobalDictType<any>;
	colors: {
		tw: TwColorType;
		hex: HexColor;
	}
	tooltip?: (datapoint: PointWithData, helper?: Function) => string | string[]
}

export type GlobalDictType<T extends string | number = GlobalRecordType> = {
	[key in T]: GlobalDictDataIntf<key>
}

export type NewGlobalDictType<T extends string> = {
	[key in T]: NewGlobalDictDataIntf
}

export interface GlobalRecordBaseIntf {
	id?: string;
	timestamp: Timestamp
	timestampString?: string
}

export type GlobalIsoDateString = `${number}${number}${number}${number}-${number}${number}-${number}${number}`;
export type GlobalTimeType =
	| 'pm'
	| 'am';

export type GlobalRecordGroupType =
	| 'log'
	| 'sum'

export const GlobalRecordGroupTypes: GlobalRecordGroupType[] = [
	'log',
	'sum'
];

export type GlobalRecordGroupDict<LOG, SUM> = {
	[key in GlobalRecordGroupType]: key extends 'log' ? LOG : SUM
}

